import Avatar from '@asphalt-react/avatar';
import Breadcrumb, { Crumb, Separator } from '@asphalt-react/breadcrumb';
import Button from '@asphalt-react/button';
import Dropdown from '@asphalt-react/dropdown';
import Flag from '@asphalt-react/flag';
import Stack from '@asphalt-react/stack';
import React, { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import * as flags from 'round-flags';
import routes from '../../common/models/route-constants';
import LoadingPage from '../../common/pages/LoadingPage';
import { createNewRegion } from '../api/regionsApi';
import { countryList } from '../models/Regions';
import styles from './CreateRegionPage.module.css';

function CreateRegionPage() {
    let history = useHistory();

    const [isLoading, setIsLoading] = useState(false);

    // Input value states
    const [regions, setRegions] = useState([]);
    const [selectedRegion, setSelectedRegion] = useState('');

    // Error states
    const [regionDropdownError, setRegionDropdownError] = useState(null);

    // Cancel button click
    const handeCancelClick = () => {
        //TODO : Check for any changes and give user a prompt
        history.goBack();
    };

    // Save Button click
    const handleSaveClick = () => {
        // Check if Product Category is selected
        if (selectedRegion) {
            setRegionDropdownError(null);
        } else {
            setRegionDropdownError('A value must be selected');
        }

        if (selectedRegion) {
            setIsLoading(true);
            createNewRegion(
                selectedRegion.key.toLowerCase(),
                selectedRegion.identifier
            )
                .then((regionId) => {
                    setIsLoading(false);
                    history.push(`/${routes.ILLUSTRATIONS}/${routes.REGIONS}`, {
                        notification: {
                            title: 'Region added',
                            content: `${selectedRegion.key} has been added successfully`,
                        },
                    });
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    useEffect(() => {
        const arr = Object.keys(countryList).map((key, index) => ({
            id: index.toString(),
            key: countryList[key],
            identifier: key,
            avatar: (
                <Avatar size='xxs'>
                    <img src={flags[key]} alt={`${key} flag`} />
                </Avatar>
            ),
        }));
        setRegions(arr);
    }, []);

    return (
        <React.Fragment>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <div className={styles.createPageContainer}>
                    <div className={styles.breadcrumbContainer}>
                        <Breadcrumb>
                            <Crumb
                                text='region'
                                tagProps={{
                                    to: `/${routes.ILLUSTRATIONS}/${routes.REGIONS}`,
                                }}
                                as={Link}
                            />
                            <Separator />
                            <Crumb
                                text='add region'
                                tagProps={{
                                    to: `/${routes.ILLUSTRATIONS}/${routes.REGIONS}/${routes.CREATE}`,
                                }}
                                as={Link}
                            />
                        </Breadcrumb>
                    </div>
                    <div>
                        <h3 className={styles.heading}>Add Region</h3>

                        <div className={styles.regionInputContainer}>
                            <p className={styles.inputLabel}>Region</p>
                            <div className={styles.inputContainer}>
                                <Dropdown
                                    items={regions}
                                    onChange={(selectedRegion) => {
                                        setSelectedRegion(selectedRegion);
                                        setRegionDropdownError(null);
                                    }}
                                    stretch
                                    invalid={!!regionDropdownError}
                                    typeahead
                                />
                            </div>
                            {regionDropdownError ? (
                                <Flag error title={regionDropdownError} />
                            ) : null}
                        </div>

                        <Stack>
                            <Button primary onClick={handleSaveClick}>
                                Save
                            </Button>
                            <Button secondary onClick={handeCancelClick}>
                                Cancel
                            </Button>
                        </Stack>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default CreateRegionPage;
